import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { manageDataRoute } from "../../routes/routeConstants";

export default function ProcessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const processData = async () => {
      // Create object from URL params
      const data = {};
      searchParams.forEach((value, key) => {

        data[key] = value;
        localStorage.setItem(key,value)
      });

      await new Promise((resolve) => setTimeout(resolve, 1500));
      navigate(`/${manageDataRoute.reviewBatches}`);
    };

    processData();
  }, [searchParams, navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      flexDirection="column"
      bgcolor="#f5f5f5"
    >
      <CircularProgress />
      <Typography mt={2} color="textSecondary">
        Processing...
      </Typography>
    </Box>
  );
}
